"use strict";

const { isString } = require("./strings");

/**
 * Checks if the value is a boolean type.
 * @param {*} value
 * @returns {boolean}
 */
function isBoolean(value) {
  return typeof value === "boolean";
}

/**
 * Checks if the value is truthy, including strings of "true" and "1".
 * @param {*} value
 * @returns {boolean}
 */
function isTrue(value) {
  return isString(value) ? ["true", "1"].includes(value) : !!value;
}

module.exports = {
  isBoolean,
  isTrue
};
